// src/features/notifications/services/notifications.js
import { apiClient } from '../../../services/api/client';

export const notificationsAPI = {
  // Get notifications
  getNotifications: (params = {}) => 
    apiClient.get('/api/v1/notifications/', { params }),
  
  // Create notification
  createNotification: (data) => 
    apiClient.post('/api/v1/notifications/', data),
  
  // Create bulk notifications
  createBulkNotifications: (data) => 
    apiClient.post('/api/v1/notifications/bulk', data),
  
  // V2 Poll for notifications (no session management)
  pollV2: (params = {}) => 
    apiClient.get('/api/v2/notifications/poll', { params }),
  
  // Mark as read
  markAsRead: (notificationId) => 
    apiClient.patch(`/api/v1/notifications/${notificationId}/read`),
  
  // Delete notification
  deleteNotification: (notificationId) => 
    apiClient.delete(`/api/v1/notifications/${notificationId}`),
  
  // Get stats
  getStats: (params = {}) => 
    apiClient.get('/api/v1/notifications/stats', { params }),
  
  // Cleanup expired notifications
  cleanup: () => 
    apiClient.post('/api/v1/notifications/cleanup'),
};